import type { Relationship } from '@/lib/types';

export const ORGANIZATION_HIERARCHY_FEATURE_KEY = 'organization_hierarchy';

const ORGANIZATION_HIERARCHY_FIELD_KEYS = [
  'parentOrganizationIds',
  'childOrganizationIds',
  'childOrganizationTitles',
  'organizationMemberGraphPositions',
  'organizationMemberGraphTheme',
  'organizationMemberGraphRelationships',
  'organizationTitles',
  'organizationMembers',
] as const;

const ORGANIZATION_HIERARCHY_RELATIONSHIP_TYPES = new Set([
  'organization_membership',
  'organization_part_of',
]);

export function stripOrganizationHierarchyFields<T extends Record<string, unknown>>(data: T) {
  const next = { ...data };
  ORGANIZATION_HIERARCHY_FIELD_KEYS.forEach((key) => {
    delete next[key];
  });
  return next;
}

export function isOrganizationHierarchyManagedRelationship(relationship: Relationship) {
  return !!relationship.managedBy
    && ORGANIZATION_HIERARCHY_RELATIONSHIP_TYPES.has(relationship.managedBy.type);
}
